import type { FinancialValueDisplayPreference } from '@/types/financialValueDisplay';
import { formatFinancialMetric, FundamentalValuationsType } from '@/utilities';

import { formatFinancialValue } from './formatFinancialValue';

export const formatFinancialMetricWithDisplay = (
    value: number,
    type: FundamentalValuationsType | undefined,
    preference: FinancialValueDisplayPreference,
) => {
    if (type === FundamentalValuationsType.PERCENT || type === FundamentalValuationsType.RATIO) {
        return formatFinancialMetric(value, type);
    }

    return formatFinancialValue(value, preference, {
        kind: type === FundamentalValuationsType.NUMBER ? 'number' : 'currency',
    });
};
